import { createSlice } from "@reduxjs/toolkit";
import { showRoleDetail, createRoleDetail } from "../actions";

const initialState = {
  roleDetail: [],
};

const roleDetailSlice = createSlice({
  name: "roleDetail",
  initialState,
  reducers: {},
  extraReducers: {
    [showRoleDetail.fulfilled]: (state, action) => {
      state.roleDetail = action.payload || [];
    },
    [createRoleDetail.fulfilled]: (state, action) => {
      state.roleDetail = action.payload || [];
    }
  },
});

export const responseRoleDetail = (state) => state.roleDetail;

export default roleDetailSlice.reducer;
